@if (svgIcon) {
    <mat-icon class="cs-center-content-inline"
              [svgIcon]="svgIcon"/>
} @else if (csIcon) {
    <mat-icon class="cs-center-content-inline"
              fontSet="cs-icon"
              [fontIcon]="csIcon"/>
} @else if (icon) {
    <mat-icon class="cs-center-content-inline">{{icon}}</mat-icon>
}
